export default "__VITE_ASSET__DSu7YrtU__"